import { Edit, Form, Toolbar } from 'react-admin';
import { matchPath, useLocation } from 'react-router-dom';
import { Box, CardContent } from '@mui/material';
import { GoToListButton } from '../../../components/GoToListButton';
import { OBJECTS_TYPES } from '../../../constants';
import { OfficeAside } from '../OfficeAside';
import { OfficeInputs } from '../OfficeInputs';

export const OfficeEdit = () => {
	const { pathname } = useLocation();
	const match = matchPath(
		{ path: `objects/${OBJECTS_TYPES.OFFICES}/edit/:id` },
		pathname
	);

	if (!match) {
		return null;
	}

	const { params } = match;

	return (
		<Box mt={3}>
			<GoToListButton />
			<Edit
				aside={<OfficeAside link="show" />}
				actions={false}
				resource={OBJECTS_TYPES.PROPERTIES}
				redirect={`/objects/${OBJECTS_TYPES.OFFICES}/show/${params.id}`}
				transform={values => {
					// add https:// before website if not present
					if (values.website && !values.website.startsWith('http')) {
						values.website = `https://${values.website}`;
					}
					return values;
				}}
			>
				<Form>
					<CardContent sx={{ padding: 0 }}>
						<OfficeInputs />
					</CardContent>
					<Toolbar />
				</Form>
			</Edit>
		</Box>
	);
};
